// extracted by mini-css-extract-plugin
export default {"aboutModal":"about_modal_aboutModal__TVUQU"};